import { render } from "./AccordionSection.vue?vue&type=template&id=6d666158"
import script from "./AccordionSection.vue?vue&type=script&lang=js"
export * from "./AccordionSection.vue?vue&type=script&lang=js"

import "./AccordionSection.vue?vue&type=style&index=0&id=6d666158&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__